import AddEvent from './AddEvent';

export default AddEvent;
